import React from "react";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { COST_PER_UNIT } from "MODULES/inventories/constants";
import { ConfirmAction } from "MODULES/shared/components";
import {
  CONSIGNMENT_REFERENCE_COMPANY,
  CONSIGNMENT_REFERENCE_COMPANY_ID
} from "MODULES/Receiving/constants";
import { COMPANY } from "APP_ROOT/constants";
import Form from "./Form";

export default function CancelConsignment({ editing, close, inventory }) {
  if (inventory.getIn(["consignment_details", "cancelled"])) return null;
  if (Number(inventory.get(COST_PER_UNIT)) > 0) {
    return (
      <ConfirmAction
        open={editing}
        close={close}
        onConfirm={close}
        showButton={false}
      >
        You must depreciate remaining cost before you cancel consignment.
      </ConfirmAction>
    );
  }

  return (
    <Modal open={editing} close={close} dialogClass="modal-md">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Cancel Consignment</h4>
      </Header>
      <Form
        close={close}
        enableReinitialize
        initialValues={{
          ship_to_company_id: inventory.get(CONSIGNMENT_REFERENCE_COMPANY_ID),
          ship_to_type: COMPANY
        }}
        shipToCompany={inventory.get(CONSIGNMENT_REFERENCE_COMPANY).toJS()}
      />
    </Modal>
  );
}

CancelConsignment.propTypes = {
  inventory: PropTypes.shape({}),
  editing: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/CancelConsignment/CancelConsignment.jsx